import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { NotificationService } from '../../api/services/notification.service';
import { AuthService } from '../../api/services/auth.service';
import { interval, Subscription } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-header-nav',
  standalone: true,
  imports: [CommonModule, RouterModule, MatToolbarModule, MatButtonModule, MatIconModule, MatMenuModule, MatBadgeModule],
  templateUrl: './header-nav.component.html',
  styleUrl: './header-nav.component.scss'
})
export class HeaderNavComponent implements OnInit, OnDestroy {
  isMobileMenuOpen = signal(false);
  isSmallScreen = signal(false);
  isAuthenticated = signal(false);
  unreadNotifications = 0;
  private notifPollSub: Subscription | null = null;

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
  }

  startLogin(): void {
    // Kick off the OAuth2 authorization-code flow so that when the auth-server
    // redirects the browser back to Angular's /login, it has a SavedRequest
    // waiting and posting credentials actually resumes the flow.
    this.authService.initiateOAuthLogin();
  }

  ngOnInit(): void {
    // Resolved from the session itself rather than from a cookie's presence.
    this.authService.isAuthenticatedAsync().then(signedIn => {
      this.isAuthenticated.set(signedIn);
      if (!signedIn) {
        // Anonymous visitors never trigger notification calls — those would 401
        // and cascade into the AuthInterceptor's redirect logic.
        return;
      }
      this.loadUnreadCount();
      this.notifPollSub = interval(60000).pipe(
        switchMap(() => this.notificationService.getUnreadCount().pipe(catchError(() => of(0))))
      ).subscribe(count => this.unreadNotifications = count);
    });
  }

  ngOnDestroy(): void {
    this.notifPollSub?.unsubscribe();
  }

  loadUnreadCount(): void {
    this.notificationService.getUnreadCount().pipe(catchError(() => of(0)))
      .subscribe(count => this.unreadNotifications = count);
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen.update(val => !val);
  }

  closeMobileMenu() {
    this.isMobileMenuOpen.set(false);
  }

  private checkScreenSize() {
    this.isSmallScreen.set(window.innerWidth < 768);
  }
}
